module.exports = {"back-to-media-list":"Back to media list","related":"Related media articles","see-all":"See all posts"}


//////////////////
// WEBPACK FOOTER
// ./src/translations/fr/media-post.json
// module id = RdBq
// module chunks = 0